const DEFAULT_API_BASE_URL = "https://api.eventnova.com.ng";

const getBaseUrl = () => {
  const envUrl =
    process.env.REACT_APP_API_URL ?? process.env.REACT_APP_API_BASE_URL;
  if (envUrl && envUrl.trim().length > 0) {
    return envUrl.trim();
  }

  return DEFAULT_API_BASE_URL;
};

export const API_BASE_URL = getBaseUrl();

export const buildApiUrl = (path: string) => {
  const normalizedPath = path.startsWith("/") ? path : `/${path}`;
  return `${API_BASE_URL}${normalizedPath}`;
};

export const API_WS_BASE_URL = API_BASE_URL.startsWith("https")
  ? API_BASE_URL.replace("https", "wss")
  : API_BASE_URL.replace("http", "ws");

export const buildWsUrl = (path: string) => {
  const normalizedPath = path.startsWith("/") ? path : `/${path}`;
  // Use API_WS_BASE_URL directly for cleaner WebSocket URL construction
  return `${API_WS_BASE_URL}${normalizedPath}`;
};
